class Stackorder {
    constructor(stackorder) {
        Object.assign(this, structuredClone(stackorder), {});
    }
    get isActive() {
        if (!this.to) {
            return true;
        }
        return this.to > new Date().toISOString();
    }
}
export default Stackorder;
